import { render, staticRenderFns } from "./SidebarHeading.vue?vue&type=template&id=5c7537ef&scoped=true&"
import script from "./SidebarHeading.vue?vue&type=script&lang=js&"
export * from "./SidebarHeading.vue?vue&type=script&lang=js&"
import style0 from "./SidebarHeading.vue?vue&type=style&index=0&id=5c7537ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7537ef",
  null
  
)

export default component.exports